const email1 = {
  id: 1,
  passage: `Alex Carter [9:15 A.M.]
Hi, I ordered a package last week, and I just got a notification that it was delivered yesterday.
But I checked my front door and the package is not there.

Delivery Support [9:17 A.M.]
Hi Alex, thanks for reaching out.
Could you check if someone else at your residence might have received it?
Sometimes packages are left with neighbors or at the apartment office.

Alex Carter [9:19 A.M.]
I already checked with my neighbors, and no one has seen it.
I also called my apartment office, and they don't have it either.

Delivery Support [9:21 A.M.]
Understood. Let me check with the driver to see if there are any additional delivery details.
If we can't locate the package, we'll issue a refund or send a replacement.

Alex Carter [9:23 A.M.]
I appreciate it. I really need that package soon.`,

  translation: `알렉스 카터 [9:15 A.M.]
안녕하세요, 지난주에 주문한 택배가 어제 배달되었다는 알림을 받았습니다.
하지만 현관문을 확인해보니 택배가 없네요.

배송 지원팀 [9:17 A.M.]
알렉스 님, 연락 주셔서 감사합니다.
혹시 같은 건물에 사는 다른 분이 수령하셨을 수도 있는데 확인해보셨나요?
때로는 이웃이나 아파트 관리실에 맡겨두기도 합니다.

알렉스 카터 [9:19 A.M.]
이미 이웃들에게 확인해봤는데, 아무도 보지 못했다고 하네요.
아파트 관리실에도 전화해봤지만, 거기에도 없다고 합니다.

Delivery Support [9:21 A.M.]
Understood. Let me check with the driver to see if there are any additional delivery details.
If we can't locate the package, we'll issue a refund or send a replacement.

Alex Carter [9:23 A.M.]
I appreciate it. I really need that package soon.`,

  koreanNouns: `Alex Carter [9:15 A.M.]
Hi, I ordered a package last week, and I just got a notification that it was delivered yesterday.
But I checked my front door and the package is not there.

Delivery Support [9:17 A.M.]
Hi Alex, thanks for reaching out.
Could you check if <mark>다른 사람</mark> at your <mark>거주지</mark> might have received it?
Sometimes packages are <mark>두고간</mark> with neighbors or at the apartment office.

Alex Carter [9:19 A.M.]
I already checked with my neighbors, and no one has seen it.
I also called my apartment office, and they don't have it <mark>역시</mark>.

Delivery Support [9:21 A.M.]
Understood. Let me check with the driver to see if there are any additional delivery details.
If we can't <mark>위치를 파악하다</mark> the package, we'll <mark>처리하다</mark> a refund or send a replacement.

Alex Carter [9:23 A.M.]
I appreciate it. I really need that package soon.`,

  wordPairs: {
    "다른 사람": "someone else",
    거주지: "residence",
    두고간: "left",
    역시: "either",
    "위치를 파악하다": "locate",
    처리하다: "issue",
  },

  questions: [],
};

const email2 = {
  id: 2,
  passage: `Emma Thompson [10:05 A.M.]
Hi Ryan, we have a problem with the catering for tomorrow's corporate luncheon.
The vendor just informed me that they won't be able to deliver the full order due to a supply issue.

Ryan Parker [10:07 A.M.]
That's not good. Do we know how much of the order they can fulfill?

Emma Thompson [10:09 A.M.]
They said they can provide only 60% of the meals.
The rest won't be available unless we switch to a different menu option.

Ryan Parker [10:11 A.M.]
Can they substitute with something similar?
We don't want major changes this late.

Emma Thompson [10:13 A.M.]
I asked, but they said the only alternative would be a vegetarian option.
Otherwise, we'll need a second vendor.

Ryan Parker [10:15 A.M.]
We don't have time to negotiate a new contract.
Let's go with their alternative for the remaining 40% of meals. Please confirm this with them ASAP.

Emma Thompson [10:17 A.M.]
Got it. I'll finalize the update and notify the client about the menu adjustment.`,

  translation: `엠마 톰슨 [오전 10:05]
안녕하세요 라이언, 내일 있을 기업 오찬 케이터링에 문제가 생겼습니다.
공급업체에서 방금 재료 문제로 전체 주문을 배달할 수 없다고 알려왔습니다.

라이언 파커 [오전 10:07]
좋지 않네요. 주문의 얼마만큼을 제공할 수 있는지 알고 있나요?

엠마 톰슨 [오전 10:09]
식사의 60%만 제공할 수 있다고 합니다.
나머지는 다른 메뉴 옵션으로 변경하지 않는 한 이용할 수 없다고 하네요.

라이언 파커 [오전 10:11]
비슷한 것으로 대체할 수 있나요?
이 시점에서 큰 변경은 원하지 않습니다.

엠마 톰슨 [오전 10:13]
문의해봤는데, 채식 옵션만이 대안이 될 수 있다고 합니다.
그렇지 않으면 두 번째 공급업체가 필요할 것 같습니다.

라이언 파커 [오전 10:15]
새로운 계약을 협상할 시간이 없습니다.
남은 40%의 식사는 그들이 제안한 대안으로 진행하죠. 가능한 한 빨리 확인 부탁드립니다.

엠마 톰슨 [오전 10:17]
알겠습니다. 업데이트를 마무리하고 고객에게 메뉴 조정에 대해 알리도록 하겠습니다.`,
  koreanNouns: `Emma Thompson [10:05 A.M.]
Hi Ryan, we have a problem with the <mark>케이터링</mark> for tomorrow's <mark>기업 오찬</mark>.
The <mark>공급업체</mark> just informed me that they won't be able to deliver the full order due to a supply issue.

Ryan Parker [10:07 A.M.]
That's not good. Do we know how much of the order they can fulfill?

Emma Thompson [10:09 A.M.]
They said they can provide only 60% of the meals.
The <mark>나머지</mark> won't be available unless we switch to a different menu option.

Ryan Parker [10:11 A.M.]
Can they <mark>대체</mark> with something similar?
We don't want major changes <mark>이 시점에서</mark>.

Emma Thompson [10:13 A.M.]
I asked, but they said the only alternative would be a vegetarian option.
<mark>그렇지 않으면</mark>, we'll need a second vendor.

Ryan Parker [10:15 A.M.]
We don't have time to negotiate a new contract.
Let's go with their alternative for the remaining 40% of meals. Please confirm this with them ASAP.

Emma Thompson [10:17 A.M.]
Got it. I'll finalize the update and notify the client about the menu adjustment.`,

  wordPairs: {
    케이터링: "catering",
    "기업 오찬": "corporate luncheon",
    공급업체: "vendor",
    나머지: "rest",
    대체: "substitute",
    "이 시점에서": "this late",
    "그렇지 않으면": "otherwise",
  },

  questions: [],
};

const email3 = {
  id: 3,
  passage: `Emma Stevens [9:30 A.M.]
I'd like to hear your thoughts on our next project.
We've been considering expanding our product line, but we need to decide which direction to take.
Do you think we should focus on new features for our existing products, or develop something entirely new?

Liam Tran [9:32 A.M.]
I think enhancing our current products makes sense.
We already have a strong customer base, and adding new features would make our brand even more competitive.

Sophia Patel [9:35 A.M.]
That could work, but if we create something completely new, we might be able to reach an entirely different market.
It would require more investment, but the long-term potential could be higher.

Emma Stevens [9:37 A.M.]
That's a good point. If we go with a new product, we'll need to conduct market research first.
Does anyone have experience with customer focus groups?

Liam Tran [9:39 A.M.]
I've worked with them before.
We could set up a small study and gather feedback from our most loyal customers.

Emma Stevens [9:41 A.M.]
Great. Let's explore both options in more detail and meet tomorrow to finalize our plan.`,

  translation: `에마 스티븐스 [오전 9:30]
다음 프로젝트에 대한 여러분의 생각을 듣고 싶습니다.
제품 라인을 확장하는 것을 고려하고 있는데, 어떤 방향으로 나아갈지 결정해야 합니다.
기존 제품의 새로운 기능에 집중해야 할까요, 아니면 완전히 새로운 것을 개발해야 할까요?

리암 트란 [오전 9:32]
현재 제품을 개선하는 것이 합리적일 것 같습니다.
이미 강력한 고객 기반이 있고, 새로운 기능을 추가하면 우리 브랜드가 더욱 경쟁력을 갖출 수 있을 것입니다.

소피아 파텔 [오전 9:35]
그것도 좋지만, 완전히 새로운 것을 만든다면 전혀 다른 시장에 진출할 수 있을 것 같아요.
더 많은 투자가 필요하겠지만, 장기적인 잠재력은 더 클 수 있습니다.

에마 스티븐스 [오전 9:37]
좋은 지적이네요. 새로운 제품을 개발하기로 한다면, 먼저 시장 조사를 해야 할 거예요.
고객 포커스 그룹 경험이 있는 분 계신가요?

리암 트란 [오전 9:39]
제가 이전에 경험해 봤습니다.
소규모 연구를 설정하고 우리의 충성 고객들로부터 피드백을 수집할 수 있습니다.

에마 스티븐스 [오전 9:41]
좋습니다. 두 가지 옵션을 더 자세히 살펴보고 내일 만나서 계획을 확정짓도록 하죠.`,

  koreanNouns: `Emma Stevens [9:30 A.M.]
I'd like to hear your thoughts on our next project.
We've been considering expanding our product line, but we need to decide which direction to take.
Do you think we should focus on new <mark>기능</mark> for our <mark>기존</mark> products, or develop something <mark>완전히</mark> new?

Liam Tran [9:32 A.M.]
I think enhancing our current products makes sense.
We already have a strong customer base, and adding new features would make our brand even more <mark>경쟁력 있는</mark>.

Sophia Patel [9:35 A.M.]
That could work, but if we create something completely new, we might be able to reach an entirely different market.
It would require more investment, but the <mark>장기적 잠재력</mark> could be higher.

Emma Stevens [9:37 A.M.]
That's a good point. If we go with a new product, we'll need to conduct market research first.
Does anyone have experience with customer <mark>소규모 조사 그룹</mark>?

Liam Tran [9:39 A.M.]
I've worked with them before.
We could set up a small study and gather feedback from our most loyal customers.

Emma Stevens [9:41 A.M.]
Great. Let's explore both options in more detail and meet tomorrow to finalize our plan.`,

  wordPairs: {
    기능: "features",
    기존: "existing",
    완전히: "entirely",
    "경쟁력 있는": "competitive",
    "장기적 잠재력": "long-term potential",
    "소규모 조사 그룹": "focus groups",
  },

  questions: [],
};

const email4 = {
  id: 4,
  passage: `Rachel Smith [2:15 P.M.]
Hi James, I just received a call from the corporate client who booked the conference hall for Friday's event. They've increased their guest count from 80 to 120 and are asking if we can accommodate the change.

James Wilson [2:17 P.M.]
That's a big jump. The current seating arrangement won't work for that many people. We'd need to reconfigure the layout, and I'm not sure we have enough catering capacity.

Rachel Smith [2:19 P.M.]
Can we adjust the seating to fit more guests? And as for the catering, maybe we can extend the buffet service time instead of doing plated meals?

James Wilson [2:21 P.M.]
I'll check with the setup team, but I think we'd have to remove the stage to add more seating. As for catering, extending the buffet might work, but the kitchen will need extra prep time.

Rachel Smith [2:23 P.M.]
Okay, let's confirm those adjustments, but we also need to discuss pricing with the client. More guests mean additional costs for food and setup.

James Wilson [2:25 P.M.]
Agreed. I'll get an updated cost estimate from the catering team and let you know. We should inform the client about the pricing adjustment before making final changes.

Rachel Smith [2:27 P.M.]
Good idea. Let me know as soon as you have the numbers.`,

  translation: `레이첼 스미스 [오후 2:15]
안녕하세요 제임스, 금요일 행사를 위해 컨퍼런스홀을 예약한 기업 고객으로부터 방금 전화를 받았어요. 손님 수가 80명에서 120명으로 늘었는데 이 변경사항을 수용할 수 있는지 문의했습니다.

제임스 윌슨 [오후 2:17]
큰 변동이네요. 현재 좌석 배치로는 그 많은 인원을 수용할 수 없을 것 같습니다. 레이아웃을 재구성해야 하고, 케이터링 수용 능력도 충분할지 모르겠네요.

레이첼 스미스 [오후 2:19]
더 많은 손님을 수용할 수 있도록 좌석을 조정할 수 있을까요? 그리고 케이터링의 경우, 정찬 대신 뷔페 서비스 시간을 연장하는 건 어떨까요?

제임스 윌슨 [오후 2:21]
설치팀에 확인해보겠지만, 좌석을 더 추가하려면 무대를 제거해야 할 것 같습니다. 케이터링의 경우, 뷔페 연장이 가능할 수 있지만 주방에서 추가 준비 시간이 필요할 거예요.

레이첼 스미스 [오후 2:23]
알겠어요, 그 조정사항들을 확인해보되, 고객과 가격도 논의해야 할 것 같네요. 손님이 늘어나면 음식과 설치에 추가 비용이 발생하니까요.

제임스 윌슨 [오후 2:25]
동의합니다. 케이터링팀으로부터 업데이트된 비용 견적을 받아보고 알려드리겠습니다. 최종 변경 전에 고객에게 가격 조정에 대해 알려야 할 것 같네요.

레이첼 스미스 [오후 2:27]
좋은 생각이에요. 금액이 나오는 대로 알려주세요.`,

  koreanNouns: `Rachel Smith [2:15 P.M.]
Hi James, I just received a call from the <mark>기업 고객</mark> who booked the conference hall for Friday's event. They've increased their guest <mark>인원</mark> from 80 to 120 and are asking if we can <mark>수용</mark> the change.

James Wilson [2:17 P.M.]
That's a big jump. The current <mark>좌석 배치</mark> won't <mark>적합</mark> for that many people. We'd need to <mark>재구성</mark> the layout, and I'm not sure we have enough <mark>단체식사서비스</mark> capacity.

Rachel Smith [2:19 P.M.]
Can we adjust the seating to <mark>맞추다</mark> more guests? And as for the <mark>단체식사서비스</mark>, maybe we can <mark>연장</mark> the buffet service time instead of doing <mark>정찬</mark>?

James Wilson [2:21 P.M.]
I'll check with the setup team, but I think we'd have to remove the stage to add more seating. As for <mark>단체식사서비스</mark>, extending the buffet might work, but the kitchen will need extra prep time.

Rachel Smith [2:23 P.M.]
Okay, let's confirm <mark>그</mark> adjustments, but we also need to discuss pricing with the client. More guests mean additional costs for food and setup.

James Wilson [2:25 P.M.]
Agreed. I'll get an updated <mark>비용 견적</mark> from the <mark>단체식사서비스</mark> team and let you know. We should inform the client about the pricing adjustment before making final changes.

Rachel Smith [2:27 P.M.]
Good idea. Let me know as soon as you have the numbers.`,

  wordPairs: {
    "기업 고객": "corporate client",
    인원: "count",
    수용: "accommodate",
    "좌석 배치": "seating arrangement",
    적합: "work",
    재구성: "reconfigure",
    단체식사서비스: "catering",
    연장: "extend",
    정찬: "plated meals",
    그: "those",
    "비용 견적": "cost estimate",
    맞추다: "fit",
  },

  questions: [],
};

const email5 = {
  id: 5,
  passage: `David Kim [10:10 A.M.]
I wanted to discuss the recent customer feedback we received.
A number of users mentioned that our mobile app is difficult to navigate.
Should we consider making adjustments to the interface?

Sophia Patel [10:12 A.M.]
That makes sense. If customers are struggling with navigation,
it could affect our user retention.
We might need to simplify some of the menus.

Mark Harrison [10:14 A.M.]
We could run a usability test and collect more data before making any major changes.
That way, we'll know exactly which features need improvement.

David Kim [10:16 A.M.]
That's a good idea.
Who on the team has experience with usability testing?

Sophia Patel [10:18 A.M.]
I've worked on user experience testing before.
We can set up a small group of test users and observe how they interact with the app.

David Kim [10:20 A.M.]
That sounds like a solid plan. Let's meet tomorrow morning to finalize the testing approach.`,

  translation: `데이비드 김 [오전 10:10]
최근 받은 고객 피드백에 대해 논의하고 싶습니다.
많은 사용자들이 우리 모바일 앱의 탐색이 어렵다고 언급했습니다.
인터페이스를 조정하는 것을 고려해봐야 할까요?

소피아 파텔 [오전 10:12]
말이 되네요. 고객들이 탐색에 어려움을 겪고 있다면,
사용자 유지율에 영향을 미칠 수 있죠.
메뉴들을 좀 더 단순화할 필요가 있을 것 같아요.

마크 해리슨 [오전 10:14]
큰 변경을 하기 전에 사용성 테스트를 실시하고 더 많은 데이터를 수집할 수 있습니다.
그러면 어떤 기능들이 개선이 필요한지 정확히 알 수 있을 거예요.

데이비드 김 [오전 10:16]
좋은 생각이네요.
팀에서 사용성 테스트 경험이 있는 사람이 누구죠?

소피아 파텔 [오전 10:18]
제가 이전에 사용자 경험 테스트를 해본 적이 있습니다.
테스트 사용자 그룹을 만들어서 앱과 어떻게 상호작용하는지 관찰할 수 있어요.

데이비드 김 [오전 10:20]
좋은 계획인 것 같네요. 내일 아침에 만나서 테스트 접근 방식을 확정짓도록 하죠.`,

  koreanNouns: `David Kim [10:10 A.M.]
I wanted to discuss the recent customer feedback we received.
<mark>다수의</mark> users mentioned that our mobile app is difficult to navigate.
Should we consider making adjustments to the interface?

Sophia Patel [10:12 A.M.]
That makes sense. If customers are struggling with navigation,
it could affect our <mark>사용자 유지율</mark>.
We might need to simplify some of the menus.

Mark Harrison [10:14 A.M.]
We could run a <mark>사용성</mark> test and collect more data before making any major changes.
That way, we'll know <mark>정확히</mark> which features need improvement.

David Kim [10:16 A.M.]
That's a good idea.
Who on the team has experience with usability testing?

Sophia Patel [10:18 A.M.]
I've worked on <mark>사용자 경험 테스트</mark> before.
We can set up a small group of test users and observe how they <mark>상호작용하는지</mark> with the app.

David Kim [10:20 A.M.]
That sounds like a <mark>확실한 계획</mark>. Let's meet tomorrow morning to finalize the testing <mark>방식</mark>.`,

  wordPairs: {
    다수의: "A number of",
    "사용자 유지율": "user retention",
    사용성: "usability",
    정확히: "exactly",
    "사용자 경험 테스트": "user experience testing",
    상호작용하는지: "interact",
    "확실한 계획": "solid plan",
    방식: "approach",
  },

  questions: [],
};

const email6 = {
  id: 6,
  passage: `Emily Chen [9:30 A.M.]
Hi John, I just received an email from our supplier. The shipment of components has been delayed due to a mechanical issue with their delivery truck. They estimate arrival by Thursday afternoon.

John Parker [9:32 A.M.]
That's problematic. We have a production run scheduled for Thursday morning. Can we source the components locally to avoid delays?

Emily Chen [9:34 A.M.]
I've contacted two local suppliers. One has sufficient stock but at a 15% higher price. The other can match our current price but requires a minimum order that exceeds our needs.

John Parker [9:36 A.M.]
Let's go with the first option to keep production on schedule. Please proceed with the order and inform the production team about the change.

Emily Chen [9:38 A.M.]
Understood. I'll place the order now and notify the team.`,

  translation: `에밀리 첸 [오전 9:30]
안녕하세요 존, 방금 공급업체로부터 이메일을 받았어요. 배송 트럭의 기계적 문제로 부품 배송이 지연되었다고 합니다. 목요일 오후에 도착할 것으로 예상된다고 하네요.

존 파커 [오전 9:32]
그건 문제가 되겠네요. 목요일 아침에 생산 일정이 잡혀있거든요. 지연을 피하기 위해 부품을 현지에서 구할 수 있을까요?

에밀리 첸 [오전 9:34]
두 곳의 현지 공급업체에 연락해봤어요. 한 곳은 충분한 재고가 있지만 가격이 15% 더 비싸고, 다른 한 곳은 현재 가격과 동일하지만 우리가 필요한 양보다 더 많은 최소 주문량이 필요하다고 하네요.

존 파커 [오전 9:36]
생산 일정을 맞추기 위해 첫 번째 옵션으로 가죠. 주문을 진행하고 생산팀에 변경사항을 알려주세요.

에밀리 첸 [오전 9:38]
알겠습니다. 지금 주문하고 팀에 알리도록 하겠습니다.`,
  koreanNouns: `Emily Chen [9:30 A.M.]
Hi John, I just received an email from our supplier. The shipment of <mark>부품</mark> has been delayed due to a mechanical issue <mark>로 인한</mark> their delivery truck. They <mark>예상하다</mark> <mark>도착</mark> by Thursday afternoon.

John Parker [9:32 A.M.]
That's <mark>문제가 되는</mark>. We have a production <mark>가동</mark> scheduled for Thursday morning. Can we <mark>조달</mark> the components <mark>현지에서</mark> to avoid delays?

Emily Chen [9:34 A.M.]
I've contacted two local suppliers. One has sufficient stock but <mark>에</mark> a 15% higher price. <mark>다른 한 곳은</mark> can <mark>맞추다</mark> our current price but requires a minimum order that exceeds our needs.

John Parker [9:36 A.M.]
Let's go with the first option to keep production on schedule. Please proceed with the order and inform the production team about the change.

Emily Chen [9:38 A.M.]
Understood. I'll place the order now and notify the team.`,

  wordPairs: {
    부품: "components",
    "로 인한": "with",
    예상하다: "estimate",
    도착: "arrival",
    "문제가 되는": "problematic",
    가동: "run",
    조달: "source",
    현지에서: "locally",
    에: "at",
    "다른 한 곳은": "The other",
    맞추다: "match",
  },

  questions: [],
};

const email7 = {
  id: 7,
  passage: `David Lee [2:15 P.M.]
Hi Mia, we just got a request from the client regarding tomorrow's presentation.
They want to move the meeting from 3 PM to 10 AM instead.

Mia Chen [2:17 P.M.]
That's a big change. I'm supposed to receive the final data analysis report from the research team by noon.

David Lee [2:19 P.M.]
I know. Can we work with an earlier version of the report, or do we need to request an expedited analysis?

Mia Chen [2:21 P.M.]
The initial version has most of the key points, but some financial projections are missing.
If the client asks about future revenue trends, we won't have precise figures.

David Lee [2:23 P.M.]
In that case, I'll check if the research team can provide at least a preliminary projection by early morning.
Meanwhile, can you adjust the slides so we have backup discussion points?

Mia Chen [2:25 P.M.]
I'll do that. Let me know as soon as you hear from them so I can finalize the deck before 9 AM.`,

  translation: `데이비드 리 [오후 2:15]
안녕하세요 미아, 내일 프레젠테이션과 관련해서 고객사로부터 요청을 받았습니다.
회의 시간을 오후 3시에서 오전 10시로 변경하고 싶다고 하네요.

미아 첸 [오후 2:17]
큰 변화네요. 연구팀으로부터 최종 데이터 분석 보고서를 정오에 받기로 되어있었는데요.

데이비드 리 [오후 2:19]
알고 있습니다. 보고서 초기 버전으로 진행할 수 있을까요, 아니면 분석 작업을 서둘러 달라고 요청해야 할까요?

미아 첸 [오후 2:21]
초기 버전에는 주요 내용이 대부분 있지만, 일부 재무 전망이 빠져있어요.
고객이 향후 수익 동향에 대해 물어보면 정확한 수치를 제시할 수 없을 것 같네요.

데이비드 리 [오후 2:23]
그렇다면, 연구팀에 이른 아침까지라도 예비 전망치를 제공할 수 있는지 확인해보겠습니다.
그동안 대체 논의 사항을 준비할 수 있도록 슬라이드를 조정해주시겠어요?

미아 첸 [오후 2:25]
알겠습니다. 연구팀 소식을 듣는 대로 알려주시면 오전 9시 전에 발표 자료를 마무리하도록 하겠습니다.`,

  koreanNouns: `David Lee [2:15 P.M.]
Hi Mia, we just got a request from the client regarding tomorrow's presentation.
They want to move the meeting from 3 PM to 10 AM <mark>대신</mark>.

Mia Chen [2:17 P.M.]
That's a big change. I'm supposed to receive the final data analysis report from the research team <mark>까지</mark> noon.

David Lee [2:19 P.M.]
I know. Can we work with an earlier version of the report, or do we need to request an <mark>신속한</mark> analysis?

Mia Chen [2:21 P.M.]
The <mark>초기</mark> version has most of the key points, but some financial projections are <mark>누락되어</mark>.
If the client asks about future <mark>수익</mark> trends, we won't have <mark>정확한</mark> <mark>수치</mark>.

David Lee [2:23 P.M.]
In that case, I'll check if the research team can provide at least a <mark>예비</mark> projection by early morning.
<mark>그동안</mark>, can you adjust the slides so we have backup discussion points?

Mia Chen [2:25 P.M.]
I'll do that. Let me know as soon as you hear from them so I can finalize the deck before 9 AM.`,

  wordPairs: {
    대신: "instead",
    까지: "by",
    신속한: "expedited",
    초기: "initial",
    누락되어: "missing",
    수익: "revenue",
    정확한: "precise",
    수치: "figures",
    예비: "preliminary",
    그동안: "meanwhile",
  },

  questions: [],
};
const email8 = {
  id: 8,
  passage: `Olivia Foster [9:45 A.M.]
Hi James, the client just requested an adjustment to the contract terms. They want to extend the service period by six months but keep the original pricing.

James Carter [9:47 A.M.]
That's going to be an issue. Our current pricing structure doesn't cover extended service without additional costs.

Olivia Foster [9:49 A.M.]
I explained that, but they said they're willing to negotiate a small price increase instead of paying the full revised rate.

James Carter [9:51 A.M.]
I need to run this by the finance team first. If they approve, we'll draft a revised contract. When do they need a final confirmation?

Olivia Foster [9:53 A.M.]
By Friday afternoon. Let me know once you hear back, so I can inform the client.`,

  translation: `올리비아 포스터 [오전 9:45]
안녕하세요 제임스, 고객사에서 계약 조건 조정을 요청했습니다. 서비스 기간을 6개월 연장하되 원래 가격을 유지하고 싶다고 합니다.

제임스 카터 [오전 9:47]
그건 문제가 될 것 같네요. 현재 가격 구조로는 추가 비용 없이 서비스 연장을 할 수 없습니다.

올리비아 포스터 [오전 9:49]
그렇게 설명했더니, 수정된 전체 요금 대신 소폭의 가격 인상을 협상할 의향이 있다고 합니다.

제임스 카터 [오전 9:51]
재무팀과 먼저 상의해봐야겠습니다. 승인이 나면 수정된 계약서를 작성하겠습니다. 최종 확인은 언제까지 필요한가요?

올리비아 포스터 [오전 9:53]
금요일 오후까지입니다. 답변을 받으시면 알려주세요, 고객사에 알려드리도록 하겠습니다.`,

  koreanNouns: `Olivia Foster [9:45 A.M.]
Hi James, the client just requested an adjustment to the <mark>계약 조건</mark>. 
They want to extend the service period <mark>~만큼</mark> six months but keep the original pricing.

James Carter [9:47 A.M.]
That's going to be an <mark>문제</mark>. Our current pricing structure doesn't <mark>감당하다</mark> extended service without additional costs.

Olivia Foster [9:49 A.M.]
I explained that, but they said they're willing to negotiate a small price increase instead of paying the full <mark>수정된</mark> rate.

James Carter [9:51 A.M.]
I need to <mark>상의하다</mark> this by the finance team first. If they approve, we'll <mark>초안을 작성하다</mark> a revised contract. 
When do they need a final confirmation?

Olivia Foster [9:53 A.M.]
By Friday afternoon. Let me know once you hear back, so I can inform the client.`,

  wordPairs: {
    "계약 조건": "contract terms",
    "~만큼": "by",
    문제: "issue",
    감당하다: "cover",
    수정된: "revised",
    상의하다: "run",
    "초안을 작성하다": "draft",
  },

  questions: [],
};

const email9 = {
  id: 9,
  passage: `Natalie Kim [9:12 A.M.]
Hi Jason, we need to finalize the training budget for the next quarter. 
The management team is considering expanding the leadership development program, which will increase costs by around 15%.

Jason Park [9:18 A.M.]
That's quite an increase. 
Do we have the flexibility to adjust other training expenses, or do we need additional funding approval?

Natalie Kim [9:22 A.M.]
We might be able to reduce the budget for external workshops, but that would limit the number of employees who can participate.

Jason Park [9:28 A.M.]
If we reallocate funds, will it be enough to cover the entire 15% increase? 
Or do we still need to request approval from Finance?

Natalie Kim [9:30 A.M.]
I'll calculate the exact figures, but I think we'll still need additional approval. 
Should I prepare a proposal for the finance director?

Jason Park [9:35 A.M.]
Yes, let's do that. 
Include a breakdown of costs and how reallocating the budget would minimize the impact. 
Let me know once it's ready.`,

  translation: `나탈리 김 [오전 9:12]
안녕하세요 제이슨, 다음 분기 교육 예산을 확정해야 합니다. 경영진이 리더십 개발 프로그램 확대를 고려하고 있는데, 이로 인해 비용이 약 15% 증가할 것 같습니다.

제이슨 박 [오전 9:18]
꽤 큰 증가폭이네요. 다른 교육 비용을 조정할 여유가 있나요, 아니면 추가 자금 승인이 필요할까요?

나탈리 김 [오전 9:22]
외부 워크샵 예산을 줄일 수는 있지만, 그러면 참여할 수 있는 직원 수가 제한될 것 같습니다.

제이슨 박 [오전 9:28]
자금을 재배정하면 15% 증가분을 모두 충당할 수 있을까요? 아니면 여전히 재무팀의 승인이 필요할까요?

나탈리 김 [오전 9:30]
정확한 수치를 계산해보겠지만, 추가 승인이 여전히 필요할 것 같습니다. 재무 이사에게 제출할 제안서를 준비할까요?

제이슨 박 [오전 9:35]
네, 그렇게 하죠. 비용 내역과 예산 재배정이 어떻게 영향을 최소화할 수 있는지 포함해 주세요. 준비되면 알려주세요.`,

  koreanNouns: `Natalie Kim [9:12 A.M.]
Hi Jason, we need to finalize the <mark>교육 예산</mark> for the <mark>다음 분기</mark>. 
The management team is considering expanding the leadership development program, which will increase costs <mark>~만큼</mark> around 15%.

Jason Park [9:18 A.M.]
That's <mark>꽤</mark> an increase. 
Do we have the flexibility to adjust other training expenses, or do we need additional <mark>자금 승인</mark>?

Natalie Kim [9:22 A.M.]
We might be able to reduce the budget for <mark>외부 워크샵</mark>, but that would limit the number of employees who can participate.

Jason Park [9:28 A.M.]
If we <mark>재배정</mark> funds, will it be enough to cover the entire 15% increase? 
Or do we still need to request approval from Finance?

Natalie Kim [9:30 A.M.]
I'll calculate the <mark>정확한 수치</mark>, but I think we'll still need additional approval. 
Should I prepare a proposal for the finance director?

Jason Park [9:35 A.M.]
Yes, let's do that. 
Include a <mark>내역</mark> of costs and how reallocating the budget would minimize the impact. 
Let me know once it's ready.`,

  wordPairs: {
    "교육 예산": "training budget",
    "다음 분기": "next quarter",
    "~만큼": "by",
    꽤: "quite",
    "자금 승인": "funding approval",
    "외부 워크샵": "external workshops",
    재배정: "reallocate",
    "정확한 수치": "exact figures",
    내역: "breakdown",
  },

  questions: [],
};

const email10 = {
  id: 10,
  passage: `Jessica Lee [9:30 A.M.]
Hi Matt, I just spoke to the rental company about the tables and chairs for tonight's event.
They said delivery might be delayed by 30 minutes.

Matt Carter [9:32 A.M.]
That's not ideal. The setup crew is scheduled to start arranging everything at 5:00 P.M.

Jessica Lee [9:34 A.M.]
How about we send someone to pick them up instead?
That way, we can make sure everything is ready on time.

Matt Carter [9:36 A.M.]
Great thinking! Can you check with them and see if pickup is an option?

Jessica Lee [9:38 A.M.]
I'll do that now. I'll also ask if they can give us a discount for the inconvenience.

Matt Carter [9:40 A.M.]
Sounds good. Let me know what they say. In the meantime, I'll get a van ready.`,

  translation: `제시카 리 [오전 9:30]
안녕하세요 매트, 방금 오늘 밤 행사에 필요한 테이블과 의자에 대해 대여 업체와 통화했어요.
배달이 30분 정도 지연될 수 있다고 하네요.

매트 카터 [오전 9:32]
그건 좋지 않네요. 설치 팀이 오후 5시에 모든 것을 배치하기로 예정되어 있는데요.

제시카 리 [오전 9:34]
대신 누군가를 보내서 직접 가져오는 건 어떨까요?
그러면 모든 것을 제시간에 준비할 수 있을 것 같아요.

매트 카터 [오전 9:36]
좋은 생각이에요! 픽업이 가능한지 확인해 볼 수 있나요?

제시카 리 [오전 9:38]
지금 확인해보겠습니다. 불편에 대한 할인도 가능한지 물어볼게요.

매트 카터 [오전 9:40]
좋습니다. 그들이 뭐라고 하는지 알려주세요. 그동안 밴을 준비해두겠습니다.`,
  koreanNouns: `Jessica Lee [9:30 A.M.]
Hi Matt, I just spoke to the rental company about the tables and chairs for tonight's event.
They said delivery might be delayed by 30 minutes.

Matt Carter [9:32 A.M.]
That's not ideal. The <mark>설치 팀</mark> is scheduled to start arranging everything at 5:00 P.M.

Jessica Lee [9:34 A.M.]
How about we send someone to pick them up instead?
That way, we can make sure everything is ready on time.

Matt Carter [9:36 A.M.]
Great thinking! Can you check with them and see if pickup is an option?

Jessica Lee [9:38 A.M.]
I'll do that now. I'll also ask if they can give us a discount for the inconvenience.

Matt Carter [9:40 A.M.]
Sounds good. Let me know what they say. <mark>그동안</mark>, I'll get a van ready.`,

  wordPairs: {
    "setup crew": "설치 팀",
    "In the meantime": "그동안",
  },

  questions: [],
};

const email11 = {
  id: 11,
  passage: `Michael Grant [10:05 A.M.]
Hi Sarah, I wanted to check if we can rent some additional equipment for tomorrow's presentation.
We'll need a projector and two wireless microphones.

Sarah Lin [10:07 A.M.]
I can call the equipment rental company and see if they have them available.
Do you need anything else?

Michael Grant [10:09 A.M.]
That should be all. Also, can you ask if they provide same-day delivery?
It would be great if they could drop everything off at the venue tonight.

Sarah Lin [10:11 A.M.]
Good idea! I'll check with them and see what options they have.
If they don't offer delivery, I can pick up the equipment myself.

Michael Grant [10:13 A.M.]
That would be a huge help! Thanks for handling this.`,

  translation: `마이클 그랜트 [오전 10:05]
안녕하세요 사라, 내일 프레젠테이션을 위해 추가 장비를 대여할 수 있는지 확인하고 싶습니다.
프로젝터와 무선 마이크 두 개가 필요할 것 같아요.

사라 린 [오전 10:07]
장비 대여 업체에 전화해서 사용 가능한지 확인해보겠습니다.
다른 필요한 것이 있나요?

마이클 그랜트 [오전 10:09]
그게 전부예요. 그리고 당일 배송이 가능한지도 문의해주시겠어요?
오늘 밤에 행사장으로 모든 것을 배달해주면 좋을 것 같아요.

사라 린 [오전 10:11]
좋은 생각이에요! 어떤 선택지가 있는지 확인해보겠습니다.
배송을 제공하지 않는다면, 제가 직접 장비를 가져올 수 있어요.

마이클 그랜트 [오전 10:13]
정말 큰 도움이 될 거예요! 처리해주셔서 감사합니다.`,
  koreanNouns: `Michael Grant [10:05 A.M.]
Hi Sarah, I wanted to check if we can rent some additional equipment for tomorrow's presentation.
We'll need a projector and two <mark>무선 마이크</mark>.

Sarah Lin [10:07 A.M.]
I can call the equipment rental company and see if they have them available.
Do you need anything else?

Michael Grant [10:09 A.M.]
That should be all. Also, can you ask if they provide same-day delivery?
It would be great if they could drop everything off at the <mark>행사장</mark> tonight.

Sarah Lin [10:11 A.M.]
Good idea! I'll check with them and see what options they have.
If they don't offer delivery, I can pick up the equipment <mark>직접</mark>.

Michael Grant [10:13 A.M.]
That would be a huge help! Thanks for handling this.`,

  wordPairs: {
    "wireless microphones": "무선 마이크",
    venue: "행사장",
    myself: "직접",
  },

  questions: [],
};

const email12 = {
  id: 12,
  passage: `Emma Lee [2:10 P.M.]
Hi Josh, I just spoke with the client about renewing their contract.
They're asking for a 10% discount if they extend their service agreement for another two years.

Josh Parker [2:15 P.M.]
That's a significant price cut. Did they give any reasoning?

Emma Lee [2:18 P.M.]
Yes, they mentioned that a competitor is offering a similar service at a lower rate.
They're willing to sign immediately if we match the price.

Josh Parker [2:22 P.M.]
We need to run this by finance before we commit.
Do you have the revised cost breakdown based on the discount?

Emma Lee [2:26 P.M.]
I'm working on it now. I should have the updated figures in the next 30 minutes.

Josh Parker [2:30 P.M.]
Great. Once we have finance's approval, we should get back to the client before the end of the day.`,

  translation: `에마 리 [오후 2:10]
안녕하세요 조쉬, 방금 고객과 계약 갱신에 대해 이야기를 나눴어요.
2년 더 서비스 계약을 연장하면 10% 할인을 요청하고 있습니다.

조쉬 파커 [오후 2:15]
상당한 가격 인하네요. 어떤 이유를 제시했나요?

에마 리 [오후 2:18]
네, 경쟁사가 더 낮은 가격으로 비슷한 서비스를 제공한다고 언급했어요.
우리가 가격을 맞춰주면 바로 계약할 의향이 있다고 합니다.

조쉬 파커 [오후 2:22]
약속하기 전에 재무팀과 상의해야 할 것 같네요.
할인을 적용한 수정된 비용 내역이 있나요?

에마 리 [오후 2:26]
지금 작업 중이에요. 30분 안에 업데이트된 수치를 보내드릴 수 있을 것 같습니다.

조쉬 파커 [오후 2:30]
좋습니다. 재무팀 승인을 받으면 오늘 안으로 고객에게 답변을 해줘야겠네요.`,

  koreanNouns: `Emma Lee [2:10 P.M.]
Hi Josh, I just spoke with the client about renewing their contract.
They're asking for a 10% discount if they extend their <mark>서비스 계약</mark> for <mark>추가</mark> two years.

Josh Parker [2:15 P.M.]
That's a significant <mark>가격 인하</mark>. Did they give any <mark>이유</mark>?

Emma Lee [2:18 P.M.]
Yes, they mentioned that a <mark>경쟁사</mark> is offering a similar service <mark>에</mark> a lower rate.
They're willing to sign immediately if we <mark>맞추다</mark> the price.

Josh Parker [2:22 P.M.]
We need to <mark>검토</mark> this by finance before we <mark>약속</mark>.
Do you have the revised <mark>비용 내역</mark> based on the discount?

Emma Lee [2:26 P.M.]
I'm working on it now. I should have the updated <mark>수치</mark> in the <mark>다음</mark> 30 minutes.

Josh Parker [2:30 P.M.]
Great. Once we have finance's approval, we should <mark>답변하다</mark> to the client before the end of the day.`,

  wordPairs: {
    "service agreement": "서비스 계약",
    another: "추가",
    "price cut": "가격 인하",
    reasoning: "이유",
    competitor: "경쟁사",
    at: "에",
    match: "맞추다",
    run: "검토",
    commit: "약속",
    "cost breakdown": "비용 내역",
    figures: "수치",
    next: "다음",
    "get back": "답변하다",
  },

  questions: [],
};

const email13 = {
  id: 13,
  passage: `Sophia Kim [오후 2:15]
Hi Alex, I just got off the call with the client. They liked the overall concept for the office redesign, but they want to make some changes to the color scheme in the meeting rooms.

Alex Chen [오후 2:18]
That's unexpected. We already ordered the paint based on the original selection. What are they asking for?

Sophia Kim [오후 2:22]
They think the dark gray makes the rooms feel too small. They're asking for a lighter shade to make the space look more open.

Alex Chen [오후 2:26]
If we switch to a lighter color, it will change the contrast with the furniture. Did they mention if they want adjustments to the furniture color as well?

Sophia Kim [오후 2:30]
They didn't mention that, but we should check. Should we show them a few new color options before making any decisions?

Alex Chen [오후 2:33]
That's a good idea. I'll create a revised color palette and send it over by the end of the day. Once they choose, we can check if our supplier can swap out the paint order.

Sophia Kim [오후 2:35]
Sounds good. Let's finalize this before Friday so we stay on schedule.`,

  translation: `소피아 김 [오후 2:15]
안녕하세요 알렉스, 방금 고객과 통화를 마쳤어요. 사무실 리디자인 전반적인 컨셉은 마음에 들어했지만, 회의실 색상 구성에 대해 몇 가지 변경을 원하네요.

알렉스 첸 [오후 2:18]
예상 밖이네요. 이미 원래 선택한 페인트를 주문했는데요. 어떤 변경을 요청하나요?

소피아 김 [오후 2:22]
짙은 회색이 공간을 너무 좁아 보이게 한다고 생각하네요. 공간이 더 넓어 보이도록 더 밝은 색조로 바꾸길 원해요.

알렉스 첸 [오후 2:26]
더 밝은 색상으로 바꾸면 가구와의 대비가 달라질 텐데요. 가구 색상도 조정하길 원하는지 언급했나요?

소피아 김 [오후 2:30]
그건 언급하지 않았지만, 확인해봐야 할 것 같아요. 결정하기 전에 새로운 색상 옵션을 몇 가지 보여드릴까요?

알렉스 첸 [오후 2:33]
좋은 생각이에요. 오늘 안으로 수정된 색상 팔레트를 만들어서 보내드리겠습니다. 선택하시면 공급업체에서 페인트 주문을 교체할 수 있는지 확인해보죠.

소피아 김 [오후 2:35]
좋아요. 일정에 맞추려면 금요일 전에 이걸 확정지어야겠네요.`,
  koreanNouns: `Sophia Kim [오후 2:15]
Hi Alex, I just got off the call with the client. They liked the overall concept for the office redesign, but they want to make some changes to the color <mark>구성</mark> in the meeting rooms.

Alex Chen [오후 2:18]
That's unexpected. We already ordered the paint based on the original selection. What are they asking for?

Sophia Kim [오후 2:22]
They think the dark gray makes the rooms feel too small. They're asking for a lighter shade to make the space look more open.

Alex Chen [오후 2:26]
If we switch to a lighter color, it will change the contrast with the furniture. Did they mention if they want adjustments to the furniture color as well?

Sophia Kim [오후 2:30]
They didn't mention that, but we should check. Should we show them a few new color options before making any decisions?

Alex Chen [오후 2:33]
That's a good idea. I'll create a revised color palette and send it over by the end of the day. Once they choose, we can check if our supplier can swap out the paint order.

Sophia Kim [오후 2:35]
Sounds good. Let's finalize this before Friday so we stay on schedule.`,

  wordPairs: {
    scheme: "구성",
  },

  questions: [],
};

const email14 = {
  id: 14,
  passage: `Anna Kim [11:20 A.M.]
Hi Daniel, I just received the first batch of samples for the new jacket line. The design looks good overall, but the stitching on the cuffs is not what we requested.

Daniel Park [11:25 A.M.]
That's strange. I confirmed with the manufacturer that they followed the updated specs. What's different?

Anna Kim [11:28 A.M.]
The cuffs were supposed to have reinforced stitching for durability, but they used a single stitch instead. I checked the sample against the approved design, and it's definitely incorrect.

Daniel Park [11:33 A.M.]
If we need them to redo the samples, production will be delayed. Do you think the current stitching is strong enough to pass quality testing?

Anna Kim [11:38 A.M.]
I don't think so. It might hold up in the short term, but after repeated washing, the cuffs could fray. We should ask them to correct it before we approve full-scale production.

Daniel Park [11:42 A.M.]
Understood. I'll contact the manufacturer now and see how quickly they can make the adjustments.`,

  translation: `안나 김 [오전 11:20]
안녕하세요 다니엘, 방금 새로운 재킷 라인의 첫 샘플을 받았어요. 전반적인 디자인은 좋아 보이지만, 소매 부분의 스티칭이 우리가 요청한 것과 다르네요.

다니엘 박 [오전 11:25]
이상하네요. 제조업체에서 업데이트된 사양을 따랐다고 확인했는데요. 어떤 점이 다른가요?

안나 김 [오전 11:28]
소매 부분은 내구성을 위해 보강 스티칭을 했어야 하는데, 대신 단일 스티치를 사용했어요. 승인된 디자인과 샘플을 비교해봤는데 확실히 잘못됐네요.

다니엘 박 [오전 11:33]
샘플을 다시 만들어야 한다면 생산이 지연될 텐데요. 현재 스티칭이 품질 테스트를 통과할 만큼 충분히 튼튼하다고 생각하시나요?

안나 김 [오전 11:38]
그렇게 생각하지 않아요. 단기적으로는 괜찮을 수 있지만, 반복적인 세탁 후에는 소매가 닳을 수 있어요. 대량 생산을 승인하기 전에 수정을 요청해야 할 것 같아요.

다니엘 박 [오전 11:42]
알겠습니다. 지금 제조업체에 연락해서 얼마나 빨리 수정할 수 있는지 확인해보겠습니다.`,

  koreanNouns: `Anna Kim [11:20 A.M.]
Hi Daniel, I just received the first <mark>입고분</mark> of samples for the new jacket line. The design looks good <mark>전반적으로</mark>, but the <mark>바느질</mark> on the <mark>소매</mark> is not what we requested.

Daniel Park [11:25 A.M.]
That's <mark>이상하다</mark>. I confirmed with the <mark>제조업체</mark> that they followed the updated specs. What's different?

Anna Kim [11:28 A.M.]
The <mark>소매</mark> were supposed to have reinforced <mark>바느질</mark> for <mark>내구성</mark>, but they used a single stitch instead. I checked the sample <mark>대비</mark> the approved design, and it's <mark>확실히</mark> incorrect.

Daniel Park [11:33 A.M.]
If we need them to <mark>다시하다</mark> the samples, production will be delayed. Do you think the current <mark>바느질</mark> is strong enough to pass quality testing?

Anna Kim [11:38 A.M.]
I don't think so. It might <mark>견디다</mark> in the short term, but after <mark>반복적인</mark> washing, the <mark>소매</mark> could <mark>닳다</mark>. We should ask them to correct it before we approve <mark>대규모</mark> production.

Daniel Park [11:42 A.M.]
Understood. I'll contact the <mark>제조업체</mark> now and see how quickly they can make the adjustments.`,

  wordPairs: {
    batch: "입고분",
    overall: "전반적으로",
    stitching: "바느질",
    cuffs: "소매",
    strange: "이상하다",
    manufacturer: "제조업체",
    durability: "내구성",
    against: "대비",
    definitely: "확실히",
    redo: "다시하다",
    "hold up": "견디다",
    repeated: "반복적인",
    fray: "닳다",
    "full-scale": "대규모",
  },

  questions: [],
};
const email15 = {
  id: 15,
  passage: `Michael [10:15 A.M.]
Hi Rachel, I just spoke with the client. They want to adjust the floor plan by adding another office space on the second floor.

Rachel [10:21 A.M.]
That's going to be difficult. Have they been informed that this will require extra work and may delay the project?

Michael [10:25 A.M.]
Not yet. I wanted to check with the design team first. If we move forward with this change, we'll need to adjust the layout and possibly extend the timeline.

Rachel [10:28 A.M.]
That makes sense. Let's get an estimate on how much time and budget this would require. If it's a major cost increase, the client might reconsider.

Michael [10:33 A.M.]
Agreed. I'll get back to you once I have more details from the design team.`,

  translation: `마이클 [오전 10:15]
안녕하세요 레이첼, 방금 고객과 이야기를 나눴어요. 2층에 사무실 공간을 하나 더 추가해서 평면도를 수정하고 싶어 합니다.

레이첼 [오전 10:21]
그건 어려울 것 같네요. 추가 작업이 필요하고 프로젝트가 지연될 수 있다는 걸 안내받으셨나요?

마이클 [오전 10:25]
아직이요. 디자인팀과 먼저 상의하고 싶었어요. 이 변경을 진행하게 되면 레이아웃을 조정하고 일정을 연장해야 할 수도 있습니다.

레이첼 [오전 10:28]
이해가 됩니다. 이를 위해 얼마나 많은 시간과 예산이 필요한지 견적을 받아봅시다. 비용이 크게 증가한다면 고객이 재고려할 수도 있겠네요.

마이클 [오전 10:33]
동의합니다. 디자인팀으로부터 더 자세한 내용을 받으면 다시 연락드리겠습니다.`,

  koreanNouns: `Michael [10:15 A.M.]
Hi Rachel, I just spoke with the client. They want to adjust the <mark>평면도</mark> by adding another office space on the <mark>2층</mark>.

Rachel [10:21 A.M.]
That's going to be difficult. Have they been informed that this will require extra work and may delay the project?

Michael [10:25 A.M.]
Not yet. I wanted to check with the design team first. If we move forward with this change, we'll need to adjust the layout and <mark>아마도</mark> extend the timeline.

Rachel [10:28 A.M.]
That makes sense. Let's get an <mark>견적</mark> on how much time and budget this would require. If it's a major cost increase, the client might reconsider.

Michael [10:33 A.M.]
Agreed. I'll get back to you once I have more details from the design team.`,

  wordPairs: {
    "floor plan": "평면도",
    "second floor": "2층",
    possibly: "아마도",
    estimate: "견적",
  },

  questions: [],
};

const email16 = {
  id: 16,
  passage: `Sophia [11:10 A.M.]
Hi Mark, I just realized there's a scheduling conflict with the corporate seminar and the wedding reception in Ballroom A this Saturday.

Mark [11:14 A.M.]
That's a big issue. Both events were confirmed weeks ago. What time is the overlap?

Sophia [11:18 A.M.]
The seminar was scheduled from 9 AM to 3 PM, and the wedding setup is supposed to start at 2 PM. That means there's an hour where both events would be using the space.

Mark [11:22 A.M.]
We can't have them setting up while the seminar is still going on. Can we adjust the schedule for one of them?

Sophia [11:26 A.M.]
I'll check if the corporate group can finish by 2 PM. If not, we might need to shift the wedding setup to Ballroom B.

Mark [11:30 A.M.]
That could work. Let me know what they say so we can inform the staff.`,

  translation: `소피아 [오전 11:10]
안녕하세요 마크, 이번 토요일 볼룸 A에서 기업 세미나와 결혼식 피로연 일정이 겹치는 것을 방금 알았어요.

마크 [오전 11:14]
큰 문제네요. 두 행사 모두 몇 주 전에 확정된 거였는데요. 어느 시간대가 겹치나요?

소피아 [오전 11:18]
세미나는 오전 9시부터 오후 3시까지 예정되어 있고, 결혼식 준비는 오후 2시에 시작하기로 되어 있어요. 즉, 한 시간 동안 두 행사가 같은 공간을 사용하게 되는 거죠.

마크 [오전 11:22]
세미나가 진행되는 동안 준비를 할 순 없죠. 둘 중 하나의 일정을 조정할 수 있을까요?

소피아 [오전 11:26]
기업 측에서 오후 2시까지 마무리할 수 있는지 확인해보겠습니다. 안 된다면 결혼식 준비를 볼룸 B로 옮겨야 할 수도 있겠네요.

마크 [오전 11:30]
그렇게 하면 될 것 같네요. 직원들에게 알려줄 수 있도록 그쪽 답변을 알려주세요.`,

  koreanNouns: `Sophia [11:10 A.M.]
Hi Mark, I just realized there's a scheduling conflict with the <mark>기업 세미나</mark> and the <mark>결혼식 피로연</mark> in Ballroom A this Saturday.

Mark [11:14 A.M.]
That's a big issue. Both events were confirmed weeks ago. What time is the <mark>겹침</mark>?

Sophia [11:18 A.M.]
The seminar was scheduled from 9 AM to 3 PM, and the wedding setup is supposed to start at 2 PM. That means there's an hour where both events would be using the space.

Mark [11:22 A.M.]
We can't have them setting up while the seminar is still going on. Can we adjust the schedule for one of them?

Sophia [11:26 A.M.]
I'll check if the corporate group can finish by 2 PM. If not, we might need to shift the wedding setup to Ballroom B.

Mark [11:30 A.M.]
That could work. Let me know what they say so we can inform the staff.`,

  wordPairs: {
    "corporate seminar": "기업 세미나",
    "wedding reception": "결혼식 피로연",
    overlap: "겹침",
  },

  questions: [],
};

const email17 = {
  id: 17,
  passage: `David [10:05 A.M.]
Hi Emily, just a heads-up—the parts for Mr. Johnson's car repair haven't arrived yet. His appointment is scheduled for this afternoon.

Emily [10:10 A.M.]
That's a problem. Did the supplier give an estimated delivery time?

David [10:13 A.M.]
They said it should arrive by tomorrow morning. We'll have to reschedule his service.

Emily [10:18 A.M.]
I'll call him now and offer to move his appointment to tomorrow afternoon. If that doesn't work, we might need to provide him with a temporary vehicle.

David [10:22 A.M.]
Good idea. Let me know what he decides so we can adjust the schedule accordingly.`,

  translation: `데이비드 [오전 10:05]
안녕하세요 에밀리, 알려드릴 게 있는데요—존슨 씨의 차량 수리 부품이 아직 도착하지 않았어요. 그의 예약은 오늘 오후로 잡혀있습니다.

에밀리 [오전 10:10]
문제가 되겠네요. 공급업체에서 예상 배송 시간을 알려주었나요?

데이비드 [오전 10:13]
내일 아침에 도착할 거라고 했어요. 서비스 일정을 다시 잡아야 할 것 같습니다.

에밀리 [오전 10:18]
지금 바로 전화해서 내일 오후로 예약을 옮기는 것을 제안해보겠습니다. 그게 안 되면 임시 차량을 제공해야 할 수도 있겠네요.

데이비드 [오전 10:22]
좋은 생각이에요. 그의 결정을 알려주시면 그에 따라 일정을 조정하도록 하겠습니다.`,

  koreanNouns: `David [10:05 A.M.]
Hi Emily, just a <mark>알림</mark>—the <mark>부품</mark> for Mr. Johnson's car repair haven't arrived yet. His appointment is scheduled for this afternoon.

Emily [10:10 A.M.]
That's a problem. Did the supplier give an estimated delivery time?

David [10:13 A.M.]
They said it should arrive by tomorrow morning. We'll have to reschedule his service.

Emily [10:18 A.M.]
I'll call him now and offer to move his appointment to tomorrow afternoon. If that doesn't work, we might need to provide him with a <mark>대체 차량</mark>.

David [10:22 A.M.]
Good idea. Let me know what he decides so we can adjust the schedule <mark>그에 따라</mark>.`,

  wordPairs: {
    "heads-up": "알림",
    parts: "부품",
    "temporary vehicle": "대체 차량",
    accordingly: "그에 따라",
  },

  questions: [],
};

const email18 = {
  id: 18,
  passage: `Customer [Tuesday, 10:20 AM]
Hi, I ordered a wireless headset from your website last week, and it arrived yesterday. However, the left speaker isn't working properly. What should I do?

Agent [Tuesday, 10:25 AM]
Hello, I'm sorry to hear that. Have you tried resetting the headset or checking if it's fully charged?

Customer [Tuesday, 10:28 AM]
Yes, I charged it overnight, and I also tried connecting it to a different device. The issue is still there.

Agent [Tuesday, 10:32 AM]
Thanks for checking. Since you're within the 30-day return period, we can offer you a replacement or a full refund. Which option would you prefer?

Customer [Tuesday, 10:36 AM]
I'd like a replacement. Do I need to send the defective one back first?

Agent [Tuesday, 10:40 AM]
Yes, please return the defective headset using the prepaid shipping label included in your original package. Once we receive it, we'll send out a new one. You'll get a confirmation email with tracking details.

Customer [Tuesday, 10:43 AM]
Got it. I'll send it back today. Thanks for your help!`,

  translation: `고객 [화요일 오전 10:20]
안녕하세요, 지난주에 귀하의 웹사이트에서 무선 헤드셋을 주문했고 어제 도착했습니다. 하지만 왼쪽 스피커가 제대로 작동하지 않네요. 어떻게 해야 하나요?

상담원 [화요일 오전 10:25]
안녕하세요, 불편을 드려 죄송합니다. 헤드셋을 리셋해보시거나 완전히 충전이 되어있는지 확인해보셨나요?

고객 [화요일 오전 10:28]
네, 밤새 충전했고 다른 기기에도 연결해봤는데 문제가 여전히 있네요.

상담원 [화요일 오전 10:32]
확인해주셔서 감사합니다. 30일 반품 기간 내이므로 교체나 전액 환불을 해드릴 수 있습니다. 어떤 옵션을 선호하시나요?

고객 [화요일 오전 10:36]
교체를 원합니다. 불량품을 먼저 보내야 하나요?

상담원 [화요일 오전 10:40]
네, 원래 패키지에 포함된 선불 배송 라벨을 사용하여 불량 헤드셋을 반품해 주세요. 저희가 받으면 새 제품을 보내드리겠습니다. 추적 정보가 포함된 확인 이메일을 받으실 거예요.

고객 [화요일 오전 10:43]
알겠습니다. 오늘 보내도록 하겠습니다. 도움 감사합니다!`,

  koreanNouns: `Customer [Tuesday, 10:20 AM]
Hi, I ordered a wireless headset from your website last week, and it arrived yesterday. However, the left speaker isn't working properly. What should I do?

Agent [Tuesday, 10:25 AM]
Hello, I'm sorry to hear that. Have you tried resetting the headset or checking if it's fully charged?

Customer [Tuesday, 10:28 AM]
Yes, I charged it overnight, and I also tried connecting it to a different device. The issue is still there.

Agent [Tuesday, 10:32 AM]
Thanks for checking. Since you're within the 30-day return period, we can offer you a replacement or a full refund. Which option would you prefer?

Customer [Tuesday, 10:36 AM]
I'd like a replacement. Do I need to send the defective one back first?

Agent [Tuesday, 10:40 AM]
Yes, please return the defective headset using the prepaid shipping label included in your original package. Once we receive it, we'll send out a new one. You'll get a confirmation email with tracking details.

Customer [Tuesday, 10:43 AM]
Got it. I'll send it back today. Thanks for your help!`,

  wordPairs: {},

  questions: [],
};

const email19 = {
  id: 19,
  passage: `Emma Carter [8:45 A.M.]
Hi, Mark. This is Emma from Unit 304. I wanted to let you know that the heater isn't working properly. It was on all night, but the room still feels really cold this morning.

Mark Reynolds [8:47 A.M.]
Hi Emma, thanks for reaching out. Have you checked if the thermostat is set correctly? Sometimes, it resets automatically after a power fluctuation.

Emma Carter [8:49 A.M.]
I haven't checked yet, but I'll do that now. If that's not the issue, what should I do?

Mark Reynolds [8:51 A.M.]
No problem. I can stop by later this afternoon to take a look. If it turns out to be a bigger issue, I'll contact a technician to get it repaired as soon as possible.

Emma Carter [8:53 A.M.]
That would be great. I really appreciate your quick response. Hopefully, it's a simple fix! Thanks again, Mark.`,

  translation: `에마 카터 [8:45 A.M.]
안녕하세요, 마크. 저는 304호에 사는 에마입니다. 히터가 제대로 작동하지 않는다는 것을 알려드리고 싶었어요. 밤새 켜져 있었는데도 오늘 아침에 방이 여전히 춥네요.

마크 레이놀즈 [8:47 A.M.]
안녕하세요 에마, 연락해 주셔서 감사합니다. 온도 조절기가 올바르게 설정되어 있는지 확인해 보셨나요? 가끔 전원 변동 후에 자동으로 재설정되기도 합니다.

에마 카터 [8:49 A.M.]
아직 확인하지 않았어요, 하지만 지금 확인해 볼게요. 만약 그게 문제가 아니라면, 어떻게 해야 하나요?

마크 레이놀즈 [8:51 A.M.]
문제 없어요. 오늘 오후에 들러서 확인해 볼 수 있어요. 만약 더 큰 문제로 판명되면, 가능한 빨리 수리할 수 있도록 기술자에게 연락하겠습니다.

에마 카터 [8:53 A.M.]
좋네요. 빠른 응답에 정말 감사드립니다. 간단히 해결되길 바랍니다! 다시 한번 감사합니다, 마크.`,
  koreanNouns: `Emma Carter [8:45 A.M.]
Hi, Mark. This is Emma from Unit 304. I wanted to let you know that the heater isn't working <mark>제대로</mark>. It was on all night, but the room still feels really cold this morning.

Mark Reynolds [8:47 A.M.]
Hi Emma, thanks for reaching out. Have you checked if the <mark>온도 조절기</mark> is set correctly? Sometimes, it resets automatically after a power <mark>변동</mark>.

Emma Carter [8:49 A.M.]
I haven't checked yet, but I'll do that now. If that's not the issue, what should I do?

Mark Reynolds [8:51 A.M.]
No problem. I can <mark>들르다</mark> later this afternoon to take a look. If it turns out to be a bigger issue, I'll contact a technician to get it repaired as soon as possible.

Emma Carter [8:53 A.M.]
That would be great. I really appreciate your quick response. Hopefully, it's a simple fix! Thanks again, Mark.`,

  wordPairs: {
    properly: "제대로",
    thermostat: "온도 조절기",
    fluctuation: "변동",
    "stop by": "들르다",
  },

  questions: [],
};

const email20 = {
  id: 20,
  passage: `Emily Watson [10:30 A.M.]
I'd like to hear your thoughts on improving workplace efficiency. Recently, a few team members mentioned that meetings are taking up too much of their time. As a result, they're struggling to keep up with deadlines. What are some possible solutions?

David Kim [10:32 A.M.]
One simple fix could be reducing the number of unnecessary meetings and replacing them with quick status updates via email or project management tools.

Sophie Martinez [10:35 A.M.]
That makes sense. We could also implement shorter, more structured meetings to keep discussions focused. Some companies have tried limiting meetings to 15 or 30 minutes, and it has helped reduce wasted time.

Emily Watson [10:37 A.M.]
That's a great idea. I'll propose this to management and see if we can adjust our current policies.

David Kim [10:39 A.M.]
Another thing to consider is encouraging deep work sessions. If employees set aside dedicated time blocks with no interruptions, they can complete tasks more efficiently.

Sophie Martinez [10:42 A.M.]
Yes, and we should also promote flexible work arrangements. Some people are more productive when they have control over their schedules. Offering hybrid work options could help employees manage their time better.

Emily Watson [10:45 A.M.]
We actually had some budget left from last quarter. Maybe we could use it to invest in better productivity tools or upgrade our workspace.

David Kim [10:47 A.M.]
I like that idea. I recently spoke with a colleague who specializes in workplace efficiency, and she suggested improving office ergonomics. Small changes, like better chairs and standing desks, can make a big difference in employee well-being.

Emily Watson [10:50 A.M.]
Let's gather more ideas and discuss them in our next team meeting. Thanks for your input, everyone!`,

  translation: `에밀리 왓슨 [10:30 A.M.]
직장 효율성 향상에 대한 여러분의 생각을 듣고 싶습니다. 최근에 몇몇 팀원들이 회의가 너무 많은 시간을 차지한다고 언급했어요. 그 결과, 그들은 마감일을 맞추는 데 어려움을 겪고 있습니다. 어떤 해결책이 있을까요?

데이비드 김 [10:32 A.M.]
한 가지 간단한 해결책은 불필요한 회의 수를 줄이고 이메일이나 프로젝트 관리 도구를 통한 빠른 상태 업데이트로 대체하는 것입니다.

소피 마르티네즈 [10:35 A.M.]
말이 되네요. 또한 더 짧고 구조화된 회의를 실시하여 논의를 집중시킬 수 있습니다. 일부 회사들은 회의를 15분이나 30분으로 제한했고, 이것이 시간 낭비를 줄이는 데 도움이 되었습니다.

에밀리 왓슨 [10:37 A.M.]
좋은 아이디어네요. 경영진에게 이 제안을 하고 현재 정책을 조정할 수 있는지 알아보겠습니다.

데이비드 김 [10:39 A.M.]
고려할 또 다른 사항은 집중 작업 세션을 장려하는 것입니다. 직원들이 방해 없이 전념할 시간 블록을 따로 마련한다면, 더 효율적으로 업무를 완료할 수 있습니다.

소피 마르티네즈 [10:42 A.M.]
네, 그리고 유연한 근무 방식도 장려해야 합니다. 일부 사람들은 자신의 일정을 통제할 수 있을 때 더 생산적입니다. 하이브리드 근무 옵션을 제공하면 직원들이 시간을 더 잘 관리하는 데 도움이 될 수 있습니다.

에밀리 왓슨 [10:45 A.M.]
사실 지난 분기에 남은 예산이 있었어요. 아마도 더 나은 생산성 도구에 투자하거나 작업 공간을 업그레이드하는 데 사용할 수 있을 것 같습니다.

데이비드 김 [10:47 A.M.]
그 아이디어가 마음에 듭니다. 최근에 직장 효율성을 전문으로 하는 동료와 이야기했는데, 그녀는 사무실 인체공학을 개선하는 것을 제안했습니다. 더 나은 의자와 스탠딩 데스크와 같은 작은 변화가 직원 복지에 큰 차이를 만들 수 있습니다.

에밀리 왓슨 [10:50 A.M.]
더 많은 아이디어를 모아서 다음 팀 회의에서 논의합시다. 여러분의 의견 감사합니다!`,
  koreanNouns: `Emily Watson [10:30 A.M.]
I'd like to hear your thoughts on improving workplace efficiency. Recently, a few team members mentioned that meetings are <mark>차지하다</mark> too much of their time. As a result, they're struggling to <mark>맞추다</mark> deadlines. What are some possible solutions?

David Kim [10:32 A.M.]
One simple fix could be reducing the number of unnecessary meetings and replacing them with quick status updates <mark>통한</mark> email or project management tools.

Sophie Martinez [10:35 A.M.]
That makes sense. We could also <mark>실시하다</mark> <mark>더 짧은</mark>, more structured meetings to keep discussions focused. Some companies have tried limiting meetings to 15 or 30 minutes, and it has helped reduce wasted time.

Emily Watson [10:37 A.M.]
That's a great idea. I'll propose this to management and see if we can adjust our current policies.

David Kim [10:39 A.M.]
Another thing to consider is encouraging <mark>집중</mark> work sessions. If employees set aside <mark>따로 확보된</mark> time blocks with no interruptions, they can complete tasks more efficiently.

Sophie Martinez [10:42 A.M.]
Yes, and we should also promote flexible work arrangements. Some people are more productive when they have control over their schedules. Offering hybrid work options could help employees manage their time better.

Emily Watson [10:45 A.M.]
We actually had some budget <mark>남은</mark> from last quarter. Maybe we could use it to invest in better productivity tools or upgrade our workspace.

David Kim [10:47 A.M.]
I like that idea. I recently spoke with a colleague who <mark>전문으로 하는</mark> workplace efficiency, and she suggested improving <mark>사무실 인체공학</mark>. Small changes, like better chairs and standing desks, can make a big difference in employee well-being.

Emily Watson [10:50 A.M.]
Let's gather more ideas and discuss them in our next team meeting. Thanks for your input, everyone!`,

  wordPairs: {
    "taking up": "차지하다",
    "keep up with": "맞추다",
    via: "통한",
    implement: "실시하다",
    shorter: "더 짧은",
    deep: "집중",
    dedicated: "따로 확보된",
    left: "남은",
    "specializes in": "전문으로 하는",
    "office ergonomics": "사무실 인체공학",
  },

  questions: [],
};

const email21 = {
  id: 21,
  passage: `Rachel Adams [10:15 A.M.]
Hey everyone, I wanted to get your thoughts on organizing a company-wide volunteer event. It could be a great way to give back to the community while also encouraging team bonding. What kind of activities do you think would work best?

James Carter [10:18 A.M.]
That sounds like a great idea! We could partner with a local food bank and help distribute meals. It's a meaningful activity, and it doesn't require any special skills, so everyone can participate.

Lisa Chang [10:21 A.M.]
I like that suggestion! Another option could be an environmental initiative, like planting trees or cleaning up a local park. It's hands-on, and we'd see the impact of our work immediately.

Rachel Adams [10:24 A.M.]
Both ideas sound great! Maybe we could send out a company-wide survey to see which option people prefer? That way, we can choose an activity that most employees are excited about.

James Carter [10:27 A.M.]
That makes sense. Also, we should consider scheduling it on a Friday afternoon so it doesn't interfere too much with work. Plus, people might be more willing to participate if they don't have to give up their weekend.

Lisa Chang [10:30 A.M.]
Good point! And if we make it an annual event, it could strengthen our company's commitment to social responsibility.

Rachel Adams [10:33 A.M.]
I love that idea. I'll bring it up with management and start working on a proposal. Once we get approval, we can start planning the details. Thanks for the input, everyone!`,

  translation: `레이첼 아담스 [10:15 A.M.]
여러분, 회사 전체 자원봉사 행사를 조직하는 것에 대한 의견을 듣고 싶었어요. 지역 사회에 환원하면서 팀 결속력도 강화할 수 있는 좋은 방법이 될 수 있을 것 같아요. 어떤 활동이 가장 적합할 것 같나요?

제임스 카터 [10:18 A.M.]
정말 좋은 아이디어네요! 지역 푸드뱅크와 협력해서 식사 배포를 도울 수 있을 것 같아요. 의미 있는 활동이고, 특별한 기술이 필요하지 않아서 모두가 참여할 수 있어요.

리사 장 [10:21 A.M.]
그 제안 좋네요! 또 다른 옵션으로는 나무 심기나 지역 공원 청소와 같은 환경 이니셔티브가 있을 수 있어요. 직접 참여할 수 있고, 우리 작업의 영향을 즉시 볼 수 있어요.

레이첼 아담스 [10:24 A.M.]
두 아이디어 모두 좋네요! 어쩌면 회사 전체 설문조사를 보내서 사람들이 어떤 옵션을 선호하는지 확인할 수 있을까요? 그렇게 하면 대부분의 직원들이 흥미를 느끼는 활동을 선택할 수 있어요.

제임스 카터 [10:27 A.M.]
말이 되네요. 또한, 금요일 오후에 일정을 잡는 것을 고려해야 할 것 같아요. 그래야 업무에 너무 많은 방해가 되지 않을 거예요. 게다가, 주말을 포기하지 않아도 되니 사람들이 더 기꺼이 참여할 수 있을 거예요.

리사 장 [10:30 A.M.]
좋은 지적이에요! 그리고 이것을 연례 행사로 만든다면, 우리 회사의 사회적 책임에 대한 약속을 강화할 수 있을 거예요.

레이첼 아담스 [10:33 A.M.]
그 아이디어 정말 좋아요. 경영진에게 이 문제를 제기하고 제안서 작성을 시작할게요. 승인을 받으면 세부 계획을 시작할 수 있어요. 여러분의 의견 감사합니다!`,

  koreanNouns: `Rachel Adams [10:15 A.M.]
Hey everyone, I wanted to get your thoughts on organizing a company-wide volunteer event. It could be a great way to give back to the community <mark>동시에</mark> encouraging team bonding. What kind of activities do you think would work best?

James Carter [10:18 A.M.]
That sounds like a great idea! We could <mark>협력하다</mark> a local food bank and help distribute meals. It's a meaningful activity, and it doesn't require any special skills, so everyone can participate.

Lisa Chang [10:21 A.M.]
I like that suggestion! Another option could be an environmental initiative, like planting trees or cleaning up a local park. It's hands-on, and we'd see the impact of our work immediately.

Rachel Adams [10:24 A.M.]
Both ideas sound great! Maybe we could send out a company-wide survey to see which option people prefer? That way, we can choose an activity that most employees are excited about.

James Carter [10:27 A.M.]
That makes sense. Also, we should consider scheduling it on a Friday afternoon so it doesn't interfere too much with work. Plus, people might be more <mark>기꺼이 ~하다</mark> participate if they don't have to give up their weekend.

Lisa Chang [10:30 A.M.]
Good point! And if we make it an annual event, it could <mark>강화하다</mark> our company's <mark>약속</mark> to social responsibility.

Rachel Adams [10:33 A.M.]
I love that idea. I'll <mark>~에게 제기하다</mark> management and start working on a proposal. Once we get approval, we can start planning the details. Thanks for the input, everyone!`,

  wordPairs: {
    "while also": "동시에",
    "partner with": "협력하다",
    "willing to": "기꺼이 ~하다",
    strengthen: "강화하다",
    commitment: "약속",
    "bring it up with": "~에게 제기하다",
  },

  questions: [],
};

export const emailQuestions = [
  email1,
  email2,
  email3,
  email4,
  email5,
  email6,
  email7,
  email8,
  email9,
  email10,
  email11,
  email12,
  email13,
  email14,
  email15,
  email16,
  email17,
  email18,
  email19,
  email20,
  email21,
];
